export const provideInfoContextKey_Protocol = 'protocol';
export const provideInfoContextKey_Score = 'score';
export const provideInfoContextKey_Expression = 'expression';
export const contextCloseMode_Safe = 'safe';
export const contextCloseMode_Force = 'force';
const contextCloseMode = [contextCloseMode_Safe, contextCloseMode_Force];
//# sourceMappingURL=types.js.map